import { render, staticRenderFns } from "./CommitteeVorstossCard.vue?vue&type=template&id=3f90eb88"
import script from "./CommitteeVorstossCard.vue?vue&type=script&lang=js"
export * from "./CommitteeVorstossCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports